<template>
  <div>
    <detialItem />
  </div>
</template>

<script>
import detialItem from "@/components/mine/orderCoupon/order/detialItem"
export default {
  components:{
    detialItem
  },
  data(){
    return {}
  }
}
</script>

<style scoped>

</style>